import { INewsDetailsModel } from 'models';
import {
  INewsDetailsCarouselModel,
  INewsDetailsContentModel,
  INewsDetailsContentWithIllustrationModel,
  NewsContentType,
} from 'models/news-details-model';
import React from 'react';
import NewsCarousel from './news-carousel';
import NewsContent from './news-content';
import NewsContentWithIllustration from './news-content-with-illustration';

import styles from './news-contents.module.scss';

type Props = {
  news: INewsDetailsModel;
};

export default function NewsContents({ news }: Props) {
  if (!news) return <></>;
  if (!news.contents || news.contents.length == 0) return <></>;

  return (
    <div className={styles.container}>
      {news.contents.map((content, index) => {
        switch (content.contentType) {
          case NewsContentType.Content:
            return (
              <NewsContent
                key={index}
                content={content.content as INewsDetailsContentModel}
              />
            );
          case NewsContentType.Carousel:
            return (
              <NewsCarousel
                key={index}
                content={content.content as INewsDetailsCarouselModel}
              />
            );
          case NewsContentType.ContentWithIllustration:
            return (
              <NewsContentWithIllustration
                key={index}
                content={
                  content.content as INewsDetailsContentWithIllustrationModel
                }
              />
            );
        }
      })}
    </div>
  );
}
